/**
 * Keeps cart/order note in sync with managed line-item metadata.
 * - Custom names (Name / Custom Name on jerseys)
 * - Rakhi gift wrap (For product, SKU, variant on gift-wrap-it lines)
 * - Free extra lace (Extra lace on Calico shoes)
 * Re-runs after add/change/remove and right before checkout.
 */
(function () {
  if (window.__tlCartCustomNameBound) return;
  window.__tlCartCustomNameBound = true;

  var syncing = false;
  var pendingTimer = null;
  var NOTE_PREFIX = /^(Free name customisation\b|Custom Name\s*:|Name\s*:|Rakhi gift wrap\b|Free extra lace\b)/i;

  function isFullCart(cart) {
    return !!(cart && Array.isArray(cart.items) && typeof cart.item_count === 'number');
  }

  function isGiftWrapItem(item) {
    if (!item) return false;
    if (item.handle === 'gift-wrap-it') return true;
    if (window.GL_GIFT_WRAP && String(item.variant_id) === String(window.GL_GIFT_WRAP.variantId)) {
      return true;
    }
    return false;
  }

  function cartJsUrl() {
    if (window.theme && theme.routes && theme.routes.cart_url) {
      var u = theme.routes.cart_url;
      return u.indexOf('.js') !== -1 ? u : u.replace(/\/?$/, '') + '.js';
    }
    return '/cart.js';
  }

  function cartUpdateUrl() {
    if (window.theme && theme.routes && theme.routes.cart_update_url) return theme.routes.cart_update_url;
    return '/cart/update.js';
  }

  function customNameFromItem(item) {
    if (!item || !item.properties) return '';
    var props = item.properties;
    var name =
      props['Custom Name'] ||
      props['Name'] ||
      props['Custom name'] ||
      props['name'] ||
      '';
    if (!name || String(name).charAt(0) === '_') return '';
    return String(name).trim();
  }

  function buildCustomNameLines(cart) {
    var lines = [];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (isGiftWrapItem(item)) continue;
      var name = customNameFromItem(item);
      if (!name) continue;
      var label = item.product_title || item.title || 'Jersey';
      lines.push('Free name customisation (' + label + '): ' + name);
    }
    return lines;
  }

  function giftWrapProp(props, key) {
    if (!props) return '';
    var v = props[key];
    return v == null ? '' : String(v).trim();
  }

  function buildGiftWrapLines(cart) {
    var lines = [];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!isGiftWrapItem(item)) continue;
      var props = item.properties || {};
      var forProduct = giftWrapProp(props, 'For product');
      var sku = giftWrapProp(props, 'Product SKU');
      var variant = giftWrapProp(props, 'Variant');
      var giftType = giftWrapProp(props, 'Gift type') || 'Rakhi gift wrap';

      if (!forProduct && !sku) continue;

      var parts = [];
      if (forProduct) parts.push('For product: ' + forProduct);
      if (sku) parts.push('Product SKU: ' + sku);
      if (variant && variant !== 'Default Title') parts.push('Variant: ' + variant);
      if (giftType) parts.push('Gift type: ' + giftType);

      lines.push('Rakhi gift wrap — ' + parts.join(' | '));
    }
    return lines;
  }

  function buildLaceLines(cart) {
    var lines = [];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (isGiftWrapItem(item)) continue;
      var props = item.properties || {};
      var extra = props['Extra lace'];
      if (!extra || String(extra).charAt(0) === '_') continue;
      extra = String(extra).trim();
      if (!extra) continue;

      var label = item.product_title || item.title || 'Shoe';
      var size = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var defLace = props['_lace_default'] ? String(props['_lace_default']).trim() : 'White';
      var where = label + (size ? ', ' + size : '');
      var qty = item.quantity > 1 ? ' x' + item.quantity : '';
      var productName = extra + ' Laces';
      lines.push(
        'Free extra lace (' + where + ')' + qty + ': ' + extra + ' (' + productName + '). Includes default ' + defLace.toLowerCase() + ' laces.'
      );
    }
    return lines;
  }

  function buildManagedLines(cart) {
    return buildCustomNameLines(cart).concat(buildGiftWrapLines(cart)).concat(buildLaceLines(cart));
  }

  function mergeNote(existing, customLines) {
    var kept = String(existing || '')
      .split(/\r?\n/)
      .map(function (l) { return l.trim(); })
      .filter(function (l) { return l && !NOTE_PREFIX.test(l); });
    return kept.concat(customLines).join('\n').trim();
  }

  function paintNoteFields(next) {
    document.querySelectorAll('cart-note textarea[name="note"], textarea[name="note"]').forEach(function (el) {
      if (el && el.value !== next) el.value = next;
    });
  }

  function syncCartCustomNameNotes(cart) {
    if (syncing) return Promise.resolve(cart);
    if (!isFullCart(cart)) {
      return fetch(cartJsUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(syncCartCustomNameNotes);
    }

    var existing = (cart.note ? String(cart.note) : '').trim();
    var next = mergeNote(existing, buildManagedLines(cart));
    paintNoteFields(next);
    if (next === existing) return Promise.resolve(cart);

    syncing = true;
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-TL-Note-Sync': '1'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ note: next })
    })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (updated) {
        paintNoteFields(next);
        return updated || cart;
      })
      .catch(function () { return cart; })
      .finally(function () { syncing = false; });
  }

  function scheduleSync(delay) {
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () {
      syncCartCustomNameNotes();
    }, typeof delay === 'number' ? delay : 120);
  }

  window.tlSyncCartCustomNameNotes = syncCartCustomNameNotes;

  document.addEventListener('cart:updated', function (e) {
    var cart = e && e.detail && e.detail.cart;
    syncCartCustomNameNotes(cart).then(function () { scheduleSync(400); });
  });

  document.addEventListener('cart:refresh', function () {
    scheduleSync(200);
    scheduleSync(700);
  });

  document.addEventListener('ajaxProduct:added', function () {
    scheduleSync(150);
    scheduleSync(500);
  });

  function bindPubsub() {
    if (!window.theme || !theme.pubsub || !theme.pubsub.subscribe || !theme.pubsub.PUB_SUB_EVENTS) return;
    if (window.__tlCartCustomNamePubsub) return;
    window.__tlCartCustomNamePubsub = true;
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cart = event && event.cart;
      syncCartCustomNameNotes(cart).then(function () { scheduleSync(450); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindPubsub);
  } else {
    bindPubsub();
  }
  setTimeout(bindPubsub, 500);
  setTimeout(bindPubsub, 1500);

  // Catch Helium / theme / GoKwik cart mutations that skip our add handler
  if (!window.__tlCartCustomNameFetchHook) {
    window.__tlCartCustomNameFetchHook = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      var headers = (init && init.headers) || {};
      var isOurSync =
        (headers['X-TL-Note-Sync'] === '1') ||
        (typeof headers.get === 'function' && headers.get('X-TL-Note-Sync') === '1');
      var isCartMutate = /\/cart\/(add|change|clear|update)(\.js)?(\?|$)/i.test(url);

      return nativeFetch.apply(this, arguments).then(function (res) {
        if (isCartMutate && !isOurSync) {
          scheduleSync(100);
          scheduleSync(450);
          scheduleSync(900);
        }
        return res;
      });
    };
  }

  // Ensure note is written right before leaving for checkout
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var checkout = t.closest(
        'button[name="checkout"], [name="checkout"], a[href*="/checkout"], .gokwik-checkout button, #gokwik-buy-now, [data-gokwik], form[action*="/cart"] button[type="submit"]'
      );
      if (!checkout || checkout.getAttribute('data-tl-note-ready') === '1') return;
      e.preventDefault();
      e.stopPropagation();
      var ready = typeof window.tlLaceReconcile === 'function' ? window.tlLaceReconcile() : Promise.resolve();
      ready.then(function () { return syncCartCustomNameNotes(); }).finally(function () {
        checkout.setAttribute('data-tl-note-ready', '1');
        checkout.click();
      });
    },
    true
  );

  // Initial pass (e.g. returning to cart with name props)
  scheduleSync(300);
})();
